import { combineReducers } from 'redux'
import addEditReducer from "./AddEditReducer";
import addEditDPReducer from "./AddEditDataProviderReducer";
import addEditDPServicesReducer from "./AddEditDPServicesReducer";
import addEditDPSourcesReducer from "./AddEditDPSourcesReducer";
import addEditCountryReducer from "./AddEditCountryReducer";
import addEditBillingGroupReducer from "./AddEditBillingGroupReducer";

const addEditRootReducer = combineReducers({
    addOrEdit: addEditReducer,
    addEditDP: addEditDPReducer,
    addEditDPService: addEditDPServicesReducer,
    addEditDPSource: addEditDPSourcesReducer,
    addEditCountry: addEditCountryReducer,
    addEditBillingGroup: addEditBillingGroupReducer
});

export default addEditRootReducer;
